import { Button } from 'antd';
import AppResult from 'components/appResults';
import Footer from 'components/footer';
import { Header } from 'components/header';
import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
    state: State = {
        hasError: false,
    };

    static getDerivedStateFromError(_: Error): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        if (process.env.NODE_ENV !== 'development') {
            // Log error to monitoring service (e.g. Sentry)
            console.error('Logged Error:', error, errorInfo);
        }
    }

    render() {
        if (this.state.hasError) {
            if (process.env.NODE_ENV === 'production') {
                return (
                    <>
                        <Header />
                        <AppResult status={'404'} title="404" subTitle="Oups ! Une erreur s’est produite." extra={<Button onClick={() => window.location.href = '/'}>Retour à l’accueil</Button>} />
                        <Footer />
                    </>
                );
            } else {
                // In development, show actual error for debugging
                return (
                    <>
                        <Header />
                        <AppResult status={'404'} title="404" subTitle="Une erreur est survenue. Consultez la console pour plus d'infos." extra={<Button style={{ border: "none", borderRadius: "50px", fontSize: "13px", color: "#FFF", background: "#80b1b2", boxShadow: "1px 3px 1px -1px #5a8484" }} onClick={() => window.location.href = '/'}>Retour à l’accueil</Button>} />
                        <Footer />
                    </>
                );
            }
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
